import { inject, Injectable } from "@angular/core";
import { ELocalStorage } from "@core/enums/LocalStorage.enum";
import { FormBuilder } from "@angular/forms";
import { LocalService } from "@core/services/local-storage.service";
import { CompaniesService } from "@modules/management/services/companies.service";
import { CompanyPermissionService } from "@core/services/company-permission.service";
import { LEVELS } from "@core/enums/Levels.enum";
import { PageInfoService } from "@metronic/layout";
import { DistrictService } from "@modules/geography/services/district.service";
import { CsRegionsService } from "@modules/geography/services/cs-regions.service";

@Injectable({
  providedIn: "root",
})
/* eslint-disable*/
export class DistrictRegionChangeFormService {
  _localStorageService = inject(LocalService);
  private _fb = inject(FormBuilder);
  private _companyPermissionService = inject(CompanyPermissionService);
  _districtService = inject(DistrictService);
  _regionService = inject(CsRegionsService);
  _companyService = inject(CompaniesService);
  _pageInfoService = inject(PageInfoService);
  hasAccess: boolean;
  isRegionAdmin = false;
  isDistrictAdmin = false;

  filterForm = this._fb.group({
    regionId: 0,
    districtId: 0,
    companyId: 0,
  });

  constructor() {
    this.initContext();
  }

  get myData() {
    return this._localStorageService.getData(ELocalStorage.USER);
  }

  initContext() {
    if (this._pageInfoService.hasContextSelect()) {
      this.hasAccess = this._companyPermissionService.checkPermission();
      this.isRegionAdmin = Boolean(
        this.myData?.regionId && this.myData?.role?.level === LEVELS.REGION
      );

      this.isDistrictAdmin = Boolean(
        this.myData?.districtId && this.myData?.role?.level === LEVELS.DISTRICT
      );
    }
  }

  // eslint-disable-next-line
  saveToLocalStorage(key: string, value: any) {
    const formValue = JSON.stringify(value);
    this._localStorageService.setData(key, formValue);
  }

  initCompany() {
    this.filterForm
      .get(ELocalStorage.COMPANY_ID)
      ?.patchValue(
        parseInt(
          this._localStorageService.getData(ELocalStorage.COMPANY_ID) ?? "1"
        )
      );
  }
}
